import styled from "styled-components";
import { colors } from "../../../theme";
import Column from "../../atoms/Column";
import Row from "../../atoms/Row";

export const Container = styled(Column)`
  margin-bottom: 20px;
`;

export const CompanyName = styled.div`
  font-size: 30px;
  font-weight: 500;
  color: ${colors.white};
  white-space: nowrap;
`;

export const JobDescContainer = styled(Row)`
  gap: 12px;
`;

export const JobDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.white};
  white-space: nowrap;
`;
